export var RecurrenceFrequency;
(function (RecurrenceFrequency) {
    RecurrenceFrequency["Daily"] = "daily";
    RecurrenceFrequency["Weekly"] = "weekly";
    RecurrenceFrequency["Monthly"] = "monthly";
    RecurrenceFrequency["Annually"] = "annually";
})(RecurrenceFrequency || (RecurrenceFrequency = {}));
// eslint-disable-next-line camelcase
export var RecurrenceDayOfMonthOption;
(function (RecurrenceDayOfMonthOption) {
    RecurrenceDayOfMonthOption["First_day"] = "first_day";
    RecurrenceDayOfMonthOption["Last_day"] = "last_day";
    RecurrenceDayOfMonthOption["Custom_day"] = "custom_day";
})(RecurrenceDayOfMonthOption || (RecurrenceDayOfMonthOption = {}));
// eslint-disable-next-line camelcase
export var RecurrenceEndType;
(function (RecurrenceEndType) {
    RecurrenceEndType["After_occurrences"] = "after_occurrences";
    RecurrenceEndType["On_date"] = "on_date";
})(RecurrenceEndType || (RecurrenceEndType = {}));
